import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './UserDashboardPage.module.scss';
import clsx from 'clsx';
import Layout from '../../components/Layout/Layout';
import StatBlock from '../../components/StatBlock/StatBlock';
import Block from '../../components/Block/Block';
import ServiceItem from '../../components/ServiceItem/ServiceItem';
import { userDashboard } from '../../redux/actions/user/userDashboard';
import { serviceList } from '../../redux/actions/service/serviceList';
const UserDashboardPage = () => {
  const dispatch = useDispatch();
  const {
    userDashboard: { data: userDashboardData, loading: userDashboardLoading, error: userDashboardError },
  } = useSelector((state) => state.user);

  const {
    serviceList: { data: serviceListData, loading: serviceListLoading, error: serviceListError },
  } = useSelector((state) => state.service);
  useEffect(() => {
    dispatch(userDashboard());
    dispatch(serviceList());
  }, []);
  const [stats, setStats] = useState([]);
  const iconDonates = () => {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-pie-chart">
        <path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path>
        <path d="M22 12A10 10 0 0 0 12 2v10z"></path>
      </svg>
    );
  };
  const iconEconomy = () => {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-users">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
        <circle cx="9" cy="7" r="4"></circle>
        <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
        <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
      </svg>
    );
  };

  const iconFirst = () => {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
        <g fill="none">
          <path fill="#0074ba" d="m18.768 11.51l-5.22-8.58c-.34-.58-.95-.93-1.62-.93h-6.59c-1.45 0-2.36 1.56-1.65 2.82a16.7 16.7 0 0 0 5.43 5.78c.76.59 1.7.91 2.67.91z" />
          <path fill="#00a6ed" d="M26.658 2h-6.59c-.67 0-1.28.35-1.62.93l-5.22 8.58h6.99c.97 0 1.9-.32 2.67-.91c2.25-1.46 4.11-3.44 5.43-5.78c.7-1.26-.21-2.82-1.66-2.82" />
          <path fill="#ffb02e" d="M15.99 30c5.545 0 10.04-4.607 10.04-10.29S21.535 9.42 15.99 9.42S5.95 14.027 5.95 19.71S10.445 30 15.99 30" />
          <path fill="#6d4534" d="M14.076 16.041a1 1 0 0 1 1-1H16a1 1 0 0 1 1 1V23a1 1 0 1 1-2 0v-5.962a1 1 0 0 1-.924-.997" />
          <path
            fill="#fcd53f"
            d="M16 28.76c-2.36 0-4.58-.94-6.24-2.65a9.1 9.1 0 0 1-2.59-6.4c0-2.42.92-4.69 2.59-6.4a8.69 8.69 0 0 1 12.49 0c3.44 3.53 3.44 9.27 0 12.8c-1.68 1.71-3.9 2.65-6.25 2.65m-.01-16.87c-1.95 0-3.91.76-5.39 2.29a7.87 7.87 0 0 0-2.23 5.53c0 2.09.79 4.05 2.23 5.53a7.48 7.48 0 0 0 5.39 2.29c2.04 0 3.95-.81 5.39-2.29c2.97-3.05 2.97-8.01 0-11.06a7.46 7.46 0 0 0-5.39-2.29"
          />
        </g>
      </svg>
    );
  };
  const iconSecond = () => {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
        <g fill="none">
          <path fill="#0074ba" d="m18.768 11.51l-5.22-8.58c-.34-.58-.95-.93-1.62-.93h-6.59c-1.45 0-2.36 1.56-1.65 2.82a16.7 16.7 0 0 0 5.43 5.78c.76.59 1.7.91 2.67.91z" />
          <path fill="#00a6ed" d="M26.658 2h-6.59c-.67 0-1.28.35-1.62.93l-5.22 8.58h6.99c.97 0 1.9-.32 2.67-.91c2.25-1.46 4.11-3.44 5.43-5.78c.7-1.26-.21-2.82-1.66-2.82" />
          <path fill="#bebebe" d="M15.96 30.001c5.545 0 10.04-4.607 10.04-10.29s-4.495-10.29-10.04-10.29s-10.04 4.607-10.04 10.29s4.495 10.29 10.04 10.29" />
          <path
            fill="#e6e6e6"
            d="M15.96 28.761c-2.36 0-4.58-.94-6.24-2.65a9.1 9.1 0 0 1-2.59-6.4c0-2.42.92-4.69 2.59-6.4a8.69 8.69 0 0 1 12.49 0c3.44 3.53 3.44 9.27 0 12.8c-1.68 1.71-3.9 2.65-6.25 2.65m-.01-16.87c-1.95 0-3.91.76-5.39 2.29a7.87 7.87 0 0 0-2.23 5.53c0 2.09.79 4.05 2.23 5.53a7.48 7.48 0 0 0 5.39 2.29c2.04 0 3.95-.81 5.39-2.29c2.97-3.05 2.97-8.01 0-11.06a7.46 7.46 0 0 0-5.39-2.29"
          />
          <path
            fill="#636363"
            d="M17.838 23.95h-3.97a1 1 0 0 1-.91-.58a1 1 0 0 1 .13-1.07l3.3-4.05c.26-.32.14-.66.1-.76a.64.64 0 0 0-.58-.4h-.05c-.32 0-.61.15-.8.41c-.32.45-.95.56-1.41.24a1.01 1.01 0 0 1-.24-1.41c.56-.79 1.47-1.26 2.44-1.26h.13c1.02.05 1.91.66 2.33 1.59c.43.96.29 2.05-.37 2.86l-1.95 2.4h1.84c.56 0 1.01.45 1.01 1.01s-.44 1.02-1 1.02"
          />
        </g>
      </svg>
    );
  };
  const iconThird = () => {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
        <g fill="none">
          <path fill="#0074ba" d="m18.768 11.51l-5.22-8.58c-.34-.58-.95-.93-1.62-.93h-6.59c-1.45 0-2.36 1.56-1.65 2.82a16.7 16.7 0 0 0 5.43 5.78c.76.59 1.7.91 2.67.91z" />
          <path fill="#00a6ed" d="M26.658 2h-6.59c-.67 0-1.28.35-1.62.93l-5.22 8.58h6.99c.97 0 1.9-.32 2.67-.91c2.25-1.46 4.11-3.44 5.43-5.78c.7-1.26-.21-2.82-1.66-2.82" />
          <path fill="#d3883e" d="M15.99 30c5.545 0 10.04-4.607 10.04-10.29S21.535 9.42 15.99 9.42S5.95 14.027 5.95 19.71S10.445 30 15.99 30" />
          <path
            fill="#f3ad61"
            d="M16 28.76c-2.36 0-4.58-.94-6.24-2.65a9.1 9.1 0 0 1-2.59-6.4c0-2.42.92-4.69 2.59-6.4a8.69 8.69 0 0 1 12.49 0c3.44 3.53 3.44 9.27 0 12.8c-1.68 1.71-3.9 2.65-6.25 2.65m-.01-16.87c-1.95 0-3.91.76-5.39 2.29a7.87 7.87 0 0 0-2.23 5.53c0 2.09.79 4.05 2.23 5.53a7.48 7.48 0 0 0 5.39 2.29c2.04 0 3.95-.81 5.39-2.29c2.97-3.05 2.97-8.01 0-11.06a7.46 7.46 0 0 0-5.39-2.29"
          />
          <path
            fill="#402a32"
            d="m17.402 18.275l1.048-1.81a.98.98 0 0 0 0-.977a.97.97 0 0 0-.844-.488h-3.092a.977.977 0 0 0 0 1.953h1.403l-.752 1.311a.96.96 0 0 0-.214.6c0 .54.438.977.977.977c.61 0 1.108.498 1.108 1.108s-.498 1.109-1.108 1.109c-.468 0-.885-.295-1.038-.733a.975.975 0 0 0-1.24-.59a.966.966 0 0 0-.59 1.241A3.06 3.06 0 0 0 15.928 24a3.053 3.053 0 0 0 3.05-3.05a3.07 3.07 0 0 0-1.576-2.675"
          />
        </g>
      </svg>
    );
  };
  const iconTop = () => {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-monitor">
        <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
        <line x1="8" y1="21" x2="16" y2="21"></line>
        <line x1="12" y1="17" x2="12" y2="21"></line>
      </svg>
    );
  };
  useEffect(() => {
    if (userDashboardData) {
      const stats = [
        {
          title: 'Донаты',
          list: [
            { label: 'Всего донатов', value: userDashboardData?.transactions?.all },
            { label: 'За месяц', value: userDashboardData?.transactions?.month },
            { label: 'За неделю', value: userDashboardData?.transactions?.week },
          ],
          icon: iconDonates(),
          color: 'var(--theme-default)',
        },
        {
          title: 'Вы сэкономили',
          list: [
            { label: ' В процентах', value: `${userDashboardData?.percents}%` },
            { label: 'Всего в деньгах', value: `${userDashboardData?.sumDiscounts} руб.` },
            { label: 'Это', value: `~${userDashboardData?.packages} маленьких паков` },
          ],
          icon: iconEconomy(),
          color: '#65c15c',
        },

        {
          reverse: true,
          title: 'Ваши фавориты',
          list: userDashboardData?.topGames?.map((item, index) => ({
            icon: index == 0 ? iconFirst() : index == 1 ? iconSecond() : index == 2 ? iconThird() : '',
            label: `${item?.game} - `,
            value: `${item?.transactionCount} донатов`,
          })),
          icon: iconTop(),
          color: '#ffb829',
        },
      ];
      setStats(stats);
    }
  }, [userDashboardData]);

  const services = [
    {
      logo: 'https://leonardo.edadeal.io/dyn/re/coupons/retailers/logos/sq/a04d111e32a64dd783466c79832466cb.png?res=xl',
      name: 'Kupikod',
      desc: '"Купикод" — это универсальный портал для геймеров, позволяющий легко пополнять баланс Steam с минимальными комиссиями.',
    },
    {
      logo: 'https://leonardo.edadeal.io/dyn/re/coupons/retailers/logos/sq/a04d111e32a64dd783466c79832466cb.png?res=xl',
      name: 'Kupikod',
      desc: '"Купикод" — это универсальный портал для геймеров, позволяющий легко пополнять баланс Steam с минимальными комиссиями.',
    },
    {
      logo: 'https://leonardo.edadeal.io/dyn/re/coupons/retailers/logos/sq/a04d111e32a64dd783466c79832466cb.png?res=xl',
      name: 'Kupikod',
      desc: '"Купикод" — это универсальный портал для геймеров, позволяющий легко пополнять баланс Steam с минимальными комиссиями.',
    },
  ];
  return (
    <>
      <div className={clsx(styles.grid)}>
        {stats?.map((item) => (
          <StatBlock {...item} />
        ))}
      </div>

      <Block title="Подключенные сервисы" className={clsx(styles.serviceBlock)}>
        <div className={clsx(styles.serviceList)}>
          {serviceListData?.map((item) => (
            <ServiceItem {...item} />
          ))}
        </div>
      </Block>
    </>
  );
};

export default UserDashboardPage;
